// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.urlID {
    padding: 20px;
    background-color: var(--settingsColorBackgroundContainer);
    min-height: 150px;
}

.urlIDTextDisplayHomeContent {
    color: var(--settingsTextColor);
    font-size: 1em;
    font-weight: bold;
}

.browserSourceDescriptionHome {
    color: var(--settingsTextColor);
    opacity: 0.6;
}

.CopyButtonBrowserSourceHome {
    text-align: center;
    padding: 1em;
}

.browserSourceLinkAndButtonHome {
    display: flex;
    gap: 1em;
    background-color: var(--GrayBlue);
    border-radius: 5px;
    box-shadow: inset 0 0 10px #050811;
}

.urlIDTextDisplayBlurHomeContent {
    text-shadow: 0 0 12px var(--HighlightBlue);
    color: transparent;
    font-size: 1em;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
}

.warningSignImage {
    max-width: 13px;
    filter: invert(58%) sepia(10%) saturate(3207%) hue-rotate(300deg)
        brightness(95%) contrast(80%);
}

.warningContainerUrlId {
    margin-top: 1em;
    text-align: center;
}

.warningSignText {
    color: rgb(196, 56, 56);
    font-weight: bold;
}

@media only screen and (max-width: 1020px) {
    .urlIDTextDisplayHomeContent {
        font-size: 0.8em;
    }

    .urlIDTextDisplayBlurHomeContent {
        font-size: 0.8em;
    }
}

@media only screen and (max-width: 923px) {
    .urlIDTextDisplayHomeContent {
        font-size: 0.6em;
    }

    .warningSignText {
        color: rgb(196, 56, 56);
        font-weight: bold;
        font-size: 12px;
    }

    .urlIDTextDisplayBlurHomeContent {
        font-size: 0.6em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Home/HomeContent/BrowserSourceLogic/BrowserSourceContent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yDAAyD;IACzD,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iCAAiC;IACjC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf;qCACiC;AACrC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".urlID {\n    padding: 20px;\n    background-color: var(--settingsColorBackgroundContainer);\n    min-height: 150px;\n}\n\n.urlIDTextDisplayHomeContent {\n    color: var(--settingsTextColor);\n    font-size: 1em;\n    font-weight: bold;\n}\n\n.browserSourceDescriptionHome {\n    color: var(--settingsTextColor);\n    opacity: 0.6;\n}\n\n.CopyButtonBrowserSourceHome {\n    text-align: center;\n    padding: 1em;\n}\n\n.browserSourceLinkAndButtonHome {\n    display: flex;\n    gap: 1em;\n    background-color: var(--GrayBlue);\n    border-radius: 5px;\n    box-shadow: inset 0 0 10px #050811;\n}\n\n.urlIDTextDisplayBlurHomeContent {\n    text-shadow: 0 0 12px var(--HighlightBlue);\n    color: transparent;\n    font-size: 1em;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n.warningSignImage {\n    max-width: 13px;\n    filter: invert(58%) sepia(10%) saturate(3207%) hue-rotate(300deg)\n        brightness(95%) contrast(80%);\n}\n\n.warningContainerUrlId {\n    margin-top: 1em;\n    text-align: center;\n}\n\n.warningSignText {\n    color: rgb(196, 56, 56);\n    font-weight: bold;\n}\n\n@media only screen and (max-width: 1020px) {\n    .urlIDTextDisplayHomeContent {\n        font-size: 0.8em;\n    }\n\n    .urlIDTextDisplayBlurHomeContent {\n        font-size: 0.8em;\n    }\n}\n\n@media only screen and (max-width: 923px) {\n    .urlIDTextDisplayHomeContent {\n        font-size: 0.6em;\n    }\n\n    .warningSignText {\n        color: rgb(196, 56, 56);\n        font-weight: bold;\n        font-size: 12px;\n    }\n\n    .urlIDTextDisplayBlurHomeContent {\n        font-size: 0.6em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
